<template>
    <div class="ds-role-check">
        <BooleanSwitch v-model="booleanModelValue" :disabled="disabled">{{ label }}</BooleanSwitch>
        <div class="ds-role-check-name">{{ name }}</div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BooleanSwitch from '@/ui/BooleanSwitch.vue'

const modelValue = defineModel()
defineProps<{
    label: string
    name: string
    disabled?: boolean
}>()

const booleanModelValue = computed({
    get: () => Boolean(modelValue.value),
    set: (value: boolean) => {
        modelValue.value = value
    }
})
</script>
